import {
  keepPreviousData,
  useQuery,
  type UseQueryResult,
} from '@tanstack/react-query';

import { getConversations } from 'api/ai-assistant/ai-assistant-api';

import { AI_ASSISTANT_CONVERSATIONS_KEY } from '../ai-assistant.constants';

interface UseApiGetConversationsArgs {
  oktaUserId: string;
  clientId: string | number;
  searchTerm?: string;
}

export const useApiGetConversations = ({
  oktaUserId,
  clientId,
  searchTerm = '',
}: UseApiGetConversationsArgs): UseQueryResult<unknown, unknown> =>
  useQuery({
    queryKey: [
      AI_ASSISTANT_CONVERSATIONS_KEY,
      oktaUserId,
      clientId,
      searchTerm,
    ],
    queryFn: () =>
      getConversations({ oktaUserId, clientId, search: searchTerm }),
    enabled: !!oktaUserId && !!clientId,
    placeholderData: keepPreviousData,
  });
